import { createAsyncThunk } from "@reduxjs/toolkit";
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

//Include Both Helper File with needed methods
import { formatQueryParams } from "helpers/format";
import facilitiesApi from "api/facilitiesApi";

export const getFacilities = createAsyncThunk("Facility" , async (params: any = {}) => {
  try{
    const response = await facilitiesApi.facilities(formatQueryParams(params))
    return response;
  }catch (error) {
    return error;
  }
});

export const getListUtility =  async(params: any = {}) => {
  try{
    const response = await facilitiesApi.facilities(formatQueryParams(params))
    return response;
  }catch (error) {
    return error;
  }
};

export const getUtilityDetail =  async(id: string | number ,  params: any = {}) => {
  try{
    const response = await facilitiesApi.getFacility(id, params)
    return response;
  }catch (error) {
    return error;
  }
};

export const postFacility = async (data: any = {}) => {
  try{
    const response = await facilitiesApi.postFacility(data);
    return response;
  }catch (error) {
    return error;
  }
};

export const putFacility = async (id: string | number , data: any = {}) => {
  try{
    const response = await facilitiesApi.putFacility(id, data);
    return response;
  }catch (error) {
    return error;
  }
};

export const putFacilityUpdateBarStatus = async (data: any = {}) => {
  try{
    const response = await facilitiesApi.updateFacilityBarStatus(data);
    return response;
  }catch (error) {
    return error;
  }
};

